import { Component, ElementRef, ViewChild } from "@angular/core";
import { CellContext, injectFlexRenderContext } from "@tanstack/angular-table";
import { OriCheckbox } from "~/components/ui/checkbox";


@Component({
    imports: [
        OriCheckbox,
    ],
    template: `
      <ori-checkbox
      #checkboxRef
      [id]="checkboxId"
        [checked]="context.row.getIsSelected()"
        (checkedChange)="onCheckedChange($event)"
        aria-label="Select row"
      ></ori-checkbox>

    `,
    standalone: true,
})
export class CheckboxRow<T> {
  private static counter = 0;
  readonly context = injectFlexRenderContext<CellContext<T, unknown>>();
  isChecked = false;

  @ViewChild('checkboxRef', { static: true }) checkboxRef!: ElementRef<HTMLInputElement>;

  checkboxId = `row-checkbox-${++CheckboxRow.counter}`;
  onCheckedChange(checked: boolean) {
      this.context.row.toggleSelected(checked);   
  }

  handleClick() {
  this.checkboxRef?.nativeElement?.blur(); 
  }
}